import { useEffect, useRef, useState } from 'react';
import { careerMediaUrl } from '../api/careers';

/** Only actual playback validates a clip; an iframe load event is not proof. */
export default function CareerVideo({ video, onVerified }) {
    const frame = useRef(null);
    const callback = useRef(onVerified);
    callback.current = onVerified;
    const [state, setState] = useState('pending');
    const embed = video.embed_url && `${video.embed_url}${video.embed_url.includes('?') ? '&' : '?'}origin=${encodeURIComponent(window.location.origin)}`;

    useEffect(() => {
        setState('pending');
        callback.current(false);
        if (!embed) return;
        const origin = new URL(embed).origin;
        const post = (data) => frame.current?.contentWindow?.postMessage(JSON.stringify(data), origin);
        const listen = () => {
            post({ event: 'listening', id: 'career-preview' });
            post({ event: 'command', func: 'addEventListener', args: ['onStateChange'] });
            post({ event: 'command', func: 'addEventListener', args: ['onError'] });
        };
        const message = (event) => {
            if (event.origin !== origin || event.source !== frame.current?.contentWindow) return;
            let data;
            try { data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; } catch { return; }
            if (!data) return;
            if (data.event === 'onReady') listen();
            const playing = (data.event === 'onStateChange' && data.info === 1)
                || (data.event === 'infoDelivery' && data.info?.playerState === 1)
                || (data['x-tiktok-player'] === true && data.type === 'onStateChange' && data.value === 1);
            const failed = data.event === 'onError' || (data['x-tiktok-player'] === true && data.type === 'onPlayerError');
            if (playing || failed) {
                setState(playing ? 'verified' : 'error');
                callback.current(!!playing);
            }
        };
        window.addEventListener('message', message);
        const timer = video.kind === 'youtube' ? setInterval(listen, 1000) : null;
        return () => { window.removeEventListener('message', message); if (timer) clearInterval(timer); };
    }, [embed, video.kind]);

    const fail = () => { setState('error'); callback.current(false); };
    return <div className="career-video-preview">
        {embed ? <iframe ref={frame} src={embed} title="Application video preview" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowFullScreen onError={fail} />
            : <video aria-label="Application video preview" controls playsInline preload="metadata" src={careerMediaUrl(video.url)}
                onPlaying={() => { setState('verified'); callback.current(true); }} onError={fail} />}
        <p className={`career-video-state ${state}`} role="status">
            {state === 'verified' ? '✓ Playback confirmed — ready to submit' : state === 'error'
                ? 'This video cannot play. Replace the link or upload a supported video.'
                : 'Press play to confirm this video works. Private or non-embeddable videos cannot be submitted.'}
        </p>
    </div>;
}
